import * as React from 'react';
import styled from 'styled-components';
import { colors } from '@omilia/theme';

const SContainer = styled.div<{ inline?: boolean }>`
  align-items: center;
  background-color: ${colors.COLOR_ORANGE_100};
  border: 1px solid ${colors.COLOR_ORANGE_300};
  border-radius: 8px;
  display: flex;
  justify-content: start;
  margin: ${({ inline }) => (inline ? '16px 0 0' : '0 16px 16px 16px')};
  padding: 16px;
`;

const SIcon = styled.div`
  flex-shrink: 0;
  min-width: 16px;
`;

const SContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 16px;
`;

const STitle = styled.span`
  color: ${colors.COLOR_ORANGE_900};
  font-size: 14px;
  font-weight: 600;
`;

const SDescription = styled.span`
  color: ${colors.COLOR_ORANGE_900};
  font-size: 14px;
  font-weight: 400;
`;

export type AgentWarningProps = {
  dataTest: string;
  description: string;
  icon: React.ReactNode;
  inline?: boolean;
  title?: string;
};

const AgentWarning = ({
  dataTest,
  description,
  icon,
  inline = false,
  title,
}: AgentWarningProps) => (
  <SContainer data-test={dataTest} inline={inline}>
    <SIcon>{icon}</SIcon>
    <SContent>
      {title && <STitle>{title}</STitle>}
      <SDescription>{description}</SDescription>
    </SContent>
  </SContainer>
);

export default AgentWarning;
